import React from 'react';
import { Card, Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { IRescheduleNotify } from '../../../../influencer/planner/dto/IPlanner';
import { manageBrand } from '../../../../../store/brand/manageBrandSlice';
import { formatDate, truncateString } from '../../../../../shared/functions/Functions';
import TooltipOverlay from '../../../../../shared/components/tooltip/Tooltip';
import { FaEllipsisV } from 'react-icons/fa';
import { AcceptIcon, DeclineIcon } from '../../../../../shared/Icons';

interface IRescheduleCardProps {
    rescheduleData: IRescheduleNotify;
    openModalActions?: (eventId: number, isApproveAction: boolean) => void;
}
export function RescheduleCard({ rescheduleData, openModalActions }: IRescheduleCardProps) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const openModal = () => {
        dispatch(
            manageBrand.actions.setOpenPreviewModal({
                eventId: rescheduleData?.event?.id,
                showPreviewEventModal: true,
            })
        );
    };
    const name = rescheduleData?.event?.user?.displayName;
    const truncatedName = truncateString(name, 25);
    const isTruncated = name.length > 25;
    return (
        <Card className="reschedule-card mb-3">
            <div
                className="d-flex align-items-center justify-content-between"
                onClick={event => {
                    event.stopPropagation();
                    openModal();
                }}
            >
                <div className="d-flex align-items-center">
                    <img className="social-icon mr-2" src={rescheduleData.event.offerItem.socialPlatform.path ?? ''} />
                    <div>
                        <TooltipOverlay content={isTruncated ? name : ''}>
                            <h6 className="mb-0">{truncatedName || '-'}</h6>
                        </TooltipOverlay>
                        <p className="mb-0 text-info">
                            {' '}
                            {t('influencer.planner.rescheduleTo')} {formatDate(rescheduleData?.postingDate)}
                        </p>
                    </div>
                </div>
                <Dropdown
                    onClick={event => {
                        event.stopPropagation();
                    }}
                >
                    <Dropdown.Toggle className="mr-2" variant="light" id="dropdown-basic">
                        <FaEllipsisV className="text-secondary" />
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        <Dropdown.Item
                            onClick={() => openModalActions && openModalActions(rescheduleData?.event?.id, true)}
                            className="d-flex align-items-center"
                        >
                            <div className="d-flex align-items-center">
                                <i className="fi fi-rr-check font-20 me-2"></i>
                                {t('general.button.accept')}
                            </div>
                        </Dropdown.Item>
                        <Dropdown.Item
                            onClick={() => openModalActions && openModalActions(rescheduleData?.event?.id, false)}
                            className="d-flex align-items-center text-danger"
                        >
                            <DeclineIcon width={20} height={20} className="me-2" />
                            {t('general.button.decline')}
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        </Card>
    );
}
